export default "__VITE_ASSET__CPbOqP97__"